import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.5 7L10.1667 17L5.5 12.0002",
		stroke: "white",
		strokeWidth: 3
	})
});
export default SvgClear;
